import { css } from "@emotion/css";

export const checkRowStyle = css({
  display: "flex",
  gap: "var(--space-2)",
  padding: "var(--space-2) var(--space-3)",
  borderRadius: "var(--border-radius-3)",
  border: "1px solid var(--border-weak)",
  cursor: "pointer",
  "&[data-selected]": {
    borderColor: "var(--border-accent)",
    background: "var(--background-surface-accent-subtle)",
  },
});

export const monitoringTabCardContainerStyle = css({
  display: "flex",
  flexDirection: "column",
  padding: "var(--space-6)",
  gap: "var(--space-8)",
});

/** Row with the check name on the left and the checkbox aligned to the right. */
export const checkRowSpaceBetweenStyle = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--space-3)",
  padding: "var(--space-3)",
  borderTop: "1px solid var(--border-weak)",
});
